import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';
import { ModalPublicProperties, AlertDocumentsLimitModalComponent as ModalComponent } from './alert-documents-limit-modal.component';

@Injectable({ providedIn: 'root' })
export class AlertDocumentsLimitModalService {
  constructor(private modalService: ModalService) {}

  open(properties?: ModalPublicProperties, options?: NgbModalOptions) {
    return this.modalService.open(ModalComponent, properties, options);
  }
}
